// services/blogService.js
const API_BASE_URL = 'https://hirecrap-backend-gcg3e8cmcgfwe6ef.westus2-01.azurewebsites.net/api/blogs';

export const blogService = {
  // Get all blogs with pagination and search
  async getBlogs(page = 1, limit = 6, search = '') {
    try {
      let url = `${API_BASE_URL}/allBlogs?page=${page}&limit=${limit}&is_published=true`;
      
      if (search && search.trim()) {
        url += `&search=${encodeURIComponent(search.trim())}`;
      }
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        return {
          blogs: result.data,
          pagination: result.pagination,
          success: true
        };
      } else {
        throw new Error('Failed to fetch blogs');
      }
    } catch (error) {
      console.error('Error fetching blogs:', error);
      return {
        blogs: [],
        pagination: null,
        success: false,
        error: error.message
      };
    }
  },

  // Get all categories
  async getAllCategories() {
    try {
      const response = await fetch(`${API_BASE_URL}/getAllCategories`, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        // Filter out "string" category if it exists
        const categories = result.data.filter(cat => cat !== 'string');
        return {
          categories: categories,
          success: true
        };
      } else {
        throw new Error('Failed to fetch categories');
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      return {
        categories: [],
        success: false,
        error: error.message
      };
    }
  },

  // Get single blog by slug
  async getBlogBySlug(slug) {
    try {
      const response = await fetch(`${API_BASE_URL}/getBlogBySlug/${slug}`, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success && result.data) {
        return {
          blog: result.data,
          success: true
        };
      } else {
        throw new Error('Blog not found');
      }
    } catch (error) {
      console.error('Error fetching blog:', error);
      return {
        blog: null,
        success: false,
        error: error.message
      };
    }
  },

  // Get featured blogs (excluding current blog)
  async getFeaturedBlogs(currentBlogId = null, limit = 3) {
    try {
      const response = await fetch(`${API_BASE_URL}/allBlogs?page=1&limit=10&is_published=true`, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.success) {
        let featuredBlogs = result.data;
        // Exclude current blog if provided
        if (currentBlogId) {
          featuredBlogs = featuredBlogs.filter(blog => blog._id !== currentBlogId);
        }
        return {
          blogs: featuredBlogs.slice(0, limit),
          success: true
        };
      } else {
        throw new Error('Failed to fetch featured blogs');
      }
    } catch (error) {
      console.error('Error fetching featured blogs:', error);
      return {
        blogs: [],
        success: false,
        error: error.message
      };
    }
  },

  async getBlogsByCategory(category, page = 1, limit = 10) {
  try {
    // Encode the category name to handle spaces and special characters
    const encodedCategory = encodeURIComponent(category);
    const url = `${API_BASE_URL}/getBlogsByCategory/${encodedCategory}?page=${page}&limit=${limit}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'accept': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (result.success) {
      // Optional: Filter to only show published blogs if the API doesn't already do this
      const publishedBlogs = result.data.filter(blog => blog.is_published === true);
      
      return {
        blogs: publishedBlogs,
        pagination: result.pagination,
        success: true
      };
    } else {
      throw new Error('Failed to fetch blogs by category');
    }
  } catch (error) {
    console.error('Error fetching blogs by category:', error);
    return {
      blogs: [],
      pagination: null,
      success: false,
      error: error.message
    };
  }
}
};